import React, { useEffect } from "react";
import Images from "config/Images";
import { 
    DonationDetailsCol,  
    DonationDetailsP, 
    DonationDetailsH2, 
    DonationDetailsWrapper, 
    DonationDetailsContentP,
    DonationDetailsRow,
    DonationDetailsCompanyName,
    DonationAmountDollars,
    DonationAmountCents,
    DonationCurrency,
    DonationDetailsBody,
    DonationImage,
    DonationDetailsFooter,
} from "./DonationDetails.styles";
import { CampaignInfo } from "types";

interface DonationDetailsProps {
  amountDollars: string,
  amountCents: string,
  campaignInfo: CampaignInfo,
  eventInfo?: EventInfo,
}

function DonationDetails({ eventInfo, campaignInfo, amountDollars, amountCents }: DonationDetailsProps) {
  useEffect(() => {
    console.log(eventInfo)
  })
  return(
    <DonationDetailsCol>
      <DonationDetailsH2>Your order:</DonationDetailsH2>
      <DonationDetailsP>Donation Details</DonationDetailsP>
      <DonationDetailsWrapper>
        <DonationDetailsBody>

          <DonationDetailsRow>
            <DonationDetailsContentP>
                Event
            </DonationDetailsContentP>
            <DonationDetailsCompanyName>
                {eventInfo?.activity ? eventInfo?.activity?.activity_title : "No event found"}
            </DonationDetailsCompanyName>
          </DonationDetailsRow>

          <DonationDetailsRow>
            <DonationDetailsContentP>
                Organizer
            </DonationDetailsContentP>
            <DonationDetailsCompanyName>
                {eventInfo?.users?.find((user: { part_type: string; }) => user.part_type === "Host")?.name ?? "No host found"}
            </DonationDetailsCompanyName>
          </DonationDetailsRow>

          <DonationDetailsRow>
            <DonationImage src={eventInfo?.visuals.length > 0 ? eventInfo?.visuals[0]?.image_url : campaignInfo.default_image}/>
          </DonationDetailsRow>

          <DonationDetailsRow>
            <DonationDetailsContentP>
                {eventInfo?.activity_description}
            </DonationDetailsContentP>
          </DonationDetailsRow>

        </DonationDetailsBody>

        <DonationDetailsFooter>
          <DonationDetailsRow>
            <DonationDetailsContentP>
              Amount
            </DonationDetailsContentP>
          </DonationDetailsRow>

          <DonationDetailsRow>
            <DonationAmountDollars>{amountDollars}</DonationAmountDollars>
            <DonationAmountCents>{`.${amountCents}`}</DonationAmountCents>
            <DonationCurrency>USD</DonationCurrency>
          </DonationDetailsRow>
        </DonationDetailsFooter>
      </DonationDetailsWrapper>
    </DonationDetailsCol> 
  );
}

export default DonationDetails;